<template>
<div class="featured-header">
    <h2>{{featuredHeader}}</h2>
</div>
</template>

<script>
export default {
  name: 'H2FeaturedHeader',
  props: {
    featuredHeader: {
        type: String,
        default: ''
    }
  }
}
</script>